// ToolSavedStylesContainer.jsx
import { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
//import ReactQuill from 'react-quill';
import ToolSavedStylesContainerEditSavedStyleDiv from './ToolSavedStylesContainerEditSavedStyleDiv';
import './CSSToolSavedStylesContainer.css';
//import './CSSToolSavedStylesContainerChildrenOfHoverStuck.css';

const ToolSavedStylesContainer = ({ savedStyles, setSavedStyles, textBoxRefs, lastFocusedEditorKey, sendSavedStyles, savedStylesForLoading, sendFavoriteVisibilityToParent, deleteFavoriteStyleFromFixedPositionFavoriteStylesContainer, onDeleteSavedStyle }) => {

    const lastLoadedJSON = useRef('');
    const [favoriteVisible, setFavoriteVisible] = useState({});
    useEffect(() => {
        Object.entries(favoriteVisible).forEach(([indexStr]) => {
            const index = parseInt(indexStr, 10);
            notifyStyleNameChange(index);
        });
    }, [savedStyles]);
    const toggleFavoriteVisible = (index, visible) => {
        const styleName = savedStyles[index]?.name || `Style ${index + 1}`;

        setFavoriteVisible(prev => {
            const currentFavorites = Object.values(prev).filter(Boolean).length;

            if (visible && !prev[index] && currentFavorites >= 6) {
                alert(`You can only save six styles as favorites at a time. Remove at least one favorite style to save ${styleName} as a favorite.`);
                if (typeof sendFavoriteVisibilityToParent === 'function') {
                    sendFavoriteVisibilityToParent(styleName, false);
                }
                return prev;
            }

            const updated = {
                ...prev,
                [index]: visible
            };

            return updated;
        });

        if (typeof sendFavoriteVisibilityToParent === 'function') {
            sendFavoriteVisibilityToParent(styleName, visible, index);
            console.log(`sendFavoriteVisibilityToParent called with styleName: ${styleName}, visible: ${visible}, index: ${index}`);
        }
    };
    const notifyStyleNameChange = (index) => {
        const styleName = savedStyles[index]?.name || `Style ${index + 1}`;
        const visible = favoriteVisible[index] || false;

        if (typeof sendFavoriteVisibilityToParent === 'function') {
            sendFavoriteVisibilityToParent(styleName, visible, index);
            console.log(`ToolSavedStylesContainer sent update for styleName, visible, index to BootstrapStarterCard:`, { styleName, visible, index });
        }
    };
    useEffect(() => {
        const currentLoadingJSON = JSON.stringify(savedStylesForLoading);

        const shouldLoad = (
            savedStylesForLoading &&
            savedStyles.length === 0 &&
            currentLoadingJSON !== lastLoadedJSON.current
        );

        if (shouldLoad) {
            console.log("Loading saved styles:", savedStylesForLoading);
            setSavedStyles(savedStylesForLoading);
            lastLoadedJSON.current = currentLoadingJSON;
        }
    }, [savedStylesForLoading, savedStyles, setSavedStyles]);
    useEffect(() => {
        // Simulate sending data up when it's ready
        sendSavedStyles(savedStyles);
    }, [savedStyles, sendSavedStyles]);
    useEffect(() => {
        savedStyles.forEach((_, index) => {
            const toolbar = document.getElementById(`quill-toolbar-${index}`);
            const selectAllButton = document.getElementById(`buttonSelectAllText-${index}`);

            if (toolbar && selectAllButton) {
                const handleMouseMove = (e) => {
                    // Check if the mouse is inside any of the exempt classes
                    if (
                        e.target.closest('.ql-color') ||
                        e.target.closest('.ql-background') ||
                        e.target.closest('.ql-picker') ||
                        e.target.closest('.ql-color-picker') ||
                        e.target.closest('.ql-expanded')
                    ) {
                        return; // If the mouse is over the exempt classes, do nothing
                    }

                    // Trigger the select all button click if the mouse is not over an exempt area
                    selectAllButton.click();
                };

                toolbar.addEventListener('mousemove', handleMouseMove);

                return () => {
                    toolbar.removeEventListener('mousemove', handleMouseMove);
                };
            }
        });
    }, [savedStyles]);
    const consoleLogSavedStyleProps = (index) => {
        console.log(`Saved Style ${index}:`, savedStyles[index]);
    };
    const applySavedStyleStylingToSavedStyleName = (index) => {
        const style = savedStyles[index];
        if (!style) {
            console.warn(`No saved style found at index ${index}`);
            return;
        }

        const quillEditor = document.querySelector(`#quill-editor-${index} .ql-editor`);
        if (!quillEditor) {
            console.warn(`Quill editor not found for saved style at index ${index}`);
            return;
        }

        // Get the Quill instance
        const quill = quillEditor.closest('.ql-container')?.__quill;
        if (!quill) {
            console.warn(`Quill instance not found for saved style at index ${index}`);
            return;
        }

        // Get the entire content of the editor as a delta
        const delta = quill.getContents();

        // Apply the saved styling formats to all the content in the editor
        Object.entries(style).forEach(([format, value]) => {
            if (format !== 'name' && format !== 'value') {
                // Apply the style to all content by formatting the entire delta
                quill.formatText(0, delta.length(), format, value);
            }
        });

        console.log(`Applied saved style to the entire content at index ${index}`);
    };
    const clearTextFormattingInSavedStyle = (index) => {
        setSavedStyles(prevStyles => {
            const updatedStyles = [...prevStyles];
            const style = updatedStyles[index];

            if (style) {
                // Clear text formatting properties (bold, italic, etc.)
                const clearedStyle = Object.fromEntries(
                    Object.entries(style).filter(([key]) => !['bold', 'italic', 'underline', 'strike', 'color', 'background'].includes(key))
                );

                updatedStyles[index] = clearedStyle; // Update the style with cleared formatting
            }

            return updatedStyles;
        });
        console.log(`Cleared text formatting for Saved Style ${index}`);
    };
    const saveCurrentStyleNamesStylingToSavedStyle = (index) => {
        const quillEditor = document.querySelector(`#quill-editor-${index} .ql-editor`);
        if (!quillEditor) {
            console.warn(`Quill editor not found for saved style at index ${index}`);
            return;
        }

        const quill = quillEditor.closest('.ql-container')?.__quill;
        if (!quill) {
            console.warn(`Quill instance not found for saved style at index ${index}`);
            return;
        }

        const length = quill.getLength();
        if (length <= 1) {
            console.warn("No content found in the editor.");
            return;
        }

        const formats = quill.getFormat(0, length - 1); // Get format for full text
        if (!formats || Object.keys(formats).length === 0) {
            console.warn("No formatting found in the full text.");
            return;
        }

        setSavedStyles(prevStyles => {
            const updatedStyles = [...prevStyles];
            const existing = updatedStyles[index] || {};
            updatedStyles[index] = { ...existing, ...formats };
            return updatedStyles;
        });

        console.log(`Applied current styles to Saved Style ${index}:`, formats);
    };
    const clickButtonEditStyleToolSave123 = (index) => {
        const click = (id) => {
            const btn = document.getElementById(id);
            if (btn) btn.click();
        };

        click(`button1ClearFormatToSavedStyle-${index}`);
        setTimeout(() => {
            click(`button2SaveCurrentStyleNamesStylingToSavedStyle-${index}`);
            setTimeout(() => {
                click(`button3EditStyleToolSave-${index}`);
            }, 50);
        }, 50);
    };
    const clickButtonEditStyleToolDiscard = (index) => {
        console.log(`Discarding edit for style ${index}:`, savedStyles[index]);

        // Clear styling in the React Quill text box
        const quillEditor = document.querySelector(`#quill-editor-${index} .ql-editor`);
        if (quillEditor) {
            const quill = quillEditor.closest('.ql-container')?.__quill;
            if (quill) {
                // Clear all formatting
                quill.removeFormat(0, quill.getLength());
                console.log(`Cleared all styling for the editor at index ${index}`);
            } else {
                console.warn(`Quill instance not found for index ${index}`);
            }
        } else {
            console.warn(`Quill editor not found for index ${index}`);
        }

        // Apply saved style to the text box
        const savedStyle = savedStyles[index];
        if (savedStyle) {
            const quillEditor = document.querySelector(`#quill-editor-${index} .ql-editor`);
            if (quillEditor) {
                const quill = quillEditor.closest('.ql-container')?.__quill;
                if (quill) {
                    // Apply saved styles
                    Object.entries(savedStyle).forEach(([format, value]) => {
                        if (format !== 'name' && format !== 'value') {
                            quill.formatText(0, quill.getLength(), format, value);
                        }
                    });
                    console.log(`Applied saved style to the editor at index ${index}`);
                } else {
                    console.warn(`Quill instance not found for index ${index}`);
                }
            } else {
                console.warn(`Quill editor not found for index ${index}`);
            }
        }
    };
    const findSavedStylesButtonContainerToDelete = (index) => {
        console.log(`findSavedStylesButtonContainerToDelete was clicked by buttonSavedStyleDelete-${index}`);
    };


    const buttonSavedStyleDeleteScanFixedPositionFavoriteStylesContainer = (index) => {
        console.log(`Scan Favorite Styles Container will scan fixedPositionFavoriteStylesContainer for ${index}`);

        const container = document.getElementById("fixedPositionFavoriteStylesContainer");
        if (container) {
            console.log("Scan Favorite Styles Container FOUND fixedPositionFavoriteStylesContainer");

            const favButtonGroupBox = container.querySelector(`#favButtonGroupBox-${index}`);
            if (favButtonGroupBox) {
                console.log(`favButtonGroupBox-${index} FOUND`);
            } else {
                console.log(`favButtonGroupBox-${index} NOT FOUND`);
            }

        } else {
            console.log("Scan Favorite Styles Container DID NOT FIND fixedPositionFavoriteStylesContainer");
        }
    };

    ////////////////////


    let currentlyStuck = null;

    // Helper functions for z-index management
    const applyZIndexToToolSavedStylesContainerPosition = () => {
        const elements = document.querySelectorAll('.toolSavedStylesContainerPosition');
        elements.forEach(el => {
            el.style.zIndex = '9999';
        });
        console.log(`Applied z-index: 9999 to ${elements.length} toolSavedStylesContainerPosition elements`);
    };

    const removeZIndexFromToolSavedStylesContainerPosition = () => {
        const elements = document.querySelectorAll('.toolSavedStylesContainerPosition');
        elements.forEach(el => {
            el.style.zIndex = '';
        });
        console.log(`Removed z-index from ${elements.length} toolSavedStylesContainerPosition elements`);
    };

    document.querySelectorAll('.savedStylesButtonContainerHoverFixedOuter').forEach(outer => {
        const inner = outer.querySelector('.savedStylesButtonContainerHoverFixedInner');

        outer.addEventListener('click', () => {
            // Remove "hover-stuck" from previously stuck
            if (currentlyStuck && currentlyStuck !== inner) {
                currentlyStuck.classList.remove('hover-stuck');
            }

            // Apply "hover-stuck" to current
            inner.classList.add('hover-stuck');
            currentlyStuck = inner;

            // Apply z-index to toolSavedStylesContainerPosition elements
            applyZIndexToToolSavedStylesContainerPosition();
        });

        outer.addEventListener('mouseleave', () => {
            // Leave unchanged or optionally auto-remove
        });
    });

    const listenForClicksOutsideHoverStuckAndUnapplyHoverStuckToAll = () => {
        document.addEventListener('click', (event) => {
            if (!event.target.closest('.savedStylesButtonContainerHoverFixedInner.hover-stuck')) {
                document.querySelectorAll('.savedStylesButtonContainerHoverFixedInner.hover-stuck').forEach(el => {
                    el.classList.remove('hover-stuck');
                });
                currentlyStuck = null;

                // Remove z-index from toolSavedStylesContainerPosition elements
                removeZIndexFromToolSavedStylesContainerPosition();
            }
        });
    };
    listenForClicksOutsideHoverStuckAndUnapplyHoverStuckToAll();


    ////////////////////

    ////////////////////



    const OldStylesManagerClicksButtonStylesInHeaderFromStylesContainer = () => {
        const button = document.getElementById('buttonStyles');
        if (button) {
            button.click();
            console.log('Clicked #buttonStyles');
        } else {
            console.warn('No button with id="buttonStyles" found in DOM');
        }
    };




    const findButtonFavoriteSavedStylesForStyleLibraryOnContainerReveal = () => {
        setTimeout(() => {
            const addToFavButtons = document.querySelectorAll('button[id^="buttonAddToFavoriteSavedStyles-"]');

            const processedIndexes = new Set();

            for (const button of addToFavButtons) {
                const id = button.id;
                const indexMatch = id.match(/buttonAddToFavoriteSavedStyles-(\d+)/);
                if (indexMatch) {
                    const index = parseInt(indexMatch[1], 10);

                    // Only act on the first and second unique indexes
                    if (!processedIndexes.has(index)) {
                        findButtonFavoriteSavedStylesForStyleLibrary(index);
                        processedIndexes.add(index);
                    }

                    if (processedIndexes.size >= 2) {
                        break; // Stop after first and second unique instances
                    }
                }
            }
        }, 10);
    };

    // 🧠 This stores which indexes have already been logged
    const loggedIndexes = new Set();
    // Track logging per index and state
    const loggedStatesByIndex = new Map();

    const findButtonFavoriteSavedStylesForStyleLibrary = (index) => {
        const button = document.getElementById(`buttonFavoriteSavedStylesForStyleLibrary-${index}`);
        const addToFavButton = document.getElementById(`buttonAddToFavoriteSavedStyles-${index}`);
        const removeFromFavButton = document.getElementById(`buttonRemoveFromFavoriteSavedStyles-${index}`);
        const addToFavButtonHover = document.getElementById(`buttonAddToFavoriteSavedStylesHoverStuck-${index}`);
        const removeFromFavButtonHover = document.getElementById(`buttonRemoveFromFavoriteSavedStylesHoverStuck-${index}`);

        const currentState = !!button; // true if FOUND, false if NOT FOUND

        // log only if the state for this index has changed
        if (loggedStatesByIndex.get(index) !== currentState) {
            const message = currentState
                ? `HELLO FOUND buttonFavoriteSavedStylesForStyleLibrary-${index}`
                : `GOODBYE NOT FOUND buttonFavoriteSavedStylesForStyleLibrary-${index}`;
            console.log(message);
            loggedStatesByIndex.set(index, currentState);
        }

        if (currentState) {
            if (addToFavButton) addToFavButton.style.display = 'none';
            if (removeFromFavButton) removeFromFavButton.style.display = 'inline-block';
            if (addToFavButtonHover) addToFavButtonHover.style.display = 'none';
            if (removeFromFavButtonHover) removeFromFavButtonHover.style.display = 'inline-block';
        } else {
            if (addToFavButton) addToFavButton.style.display = 'inline-block';
            if (removeFromFavButton) removeFromFavButton.style.display = 'none';
            if (addToFavButtonHover) addToFavButtonHover.style.display = 'inline-block';
            if (removeFromFavButtonHover) removeFromFavButtonHover.style.display = 'none';
        }
    };





    useEffect(() => {
        listeningForSavedStylesContainerReveal();
    }, []);

    const listeningForSavedStylesContainerReveal = () => {
        let lastProcessedStylesCount = 0;
        let lastProcessedStylesJSON = '';
        let lastLogTimestamp = 0;

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const savedStylesContainer = document.getElementById('savedStylesContainer');

                    if (savedStylesContainer) {
                        const currentStylesCount = savedStyles.length;
                        const currentStylesJSON = JSON.stringify(savedStyles);

                        const shouldTrigger = (
                            currentStylesCount !== lastProcessedStylesCount ||
                            currentStylesJSON !== lastProcessedStylesJSON ||
                            lastProcessedStylesCount === 0
                        );

                        if (shouldTrigger) {
                            const now = Date.now();
                            if (now - lastLogTimestamp > 1000) { // Only log once per second max
                                console.log(`savedStylesContainer detected change - styles count: ${currentStylesCount}, previous: ${lastProcessedStylesCount}`);
                                lastLogTimestamp = now;
                            }

                            lastProcessedStylesCount = currentStylesCount;
                            lastProcessedStylesJSON = currentStylesJSON;

                            setTimeout(() => {
                                findButtonFavoriteSavedStylesForStyleLibraryOnContainerReveal();
                            }, 10);
                        }
                    }
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        const timeoutId = setTimeout(() => {
            observer.disconnect();
            console.log('MutationObserver timed out and was disconnected');
        }, 60000);

        return () => {
            observer.disconnect();
            clearTimeout(timeoutId);
        };
    };


    const findAndClickHideCardMenusButton = () => {
        const button = document.getElementById("hideCardMenusButton");
        if (button) {
            button.click();
        } else {
            console.warn("hideCardMenusButton not found in the DOM.");
        }
    };



    return (
        <div
            id="savedStylesContainer"
            className="savedStylesContainer"
        >



            <div
                id="savedStylesManagerToolContainer"
                className="savedStylesManagerToolContainer"
            >
                <div
                    id="savedStylesManagerToolContainerTitleContainer"
                    className="savedStylesManagerToolContainerTitleContainer"
                >
                    <div
                        id="savedStylesManagerToolContainerTitleContainerCol01IconBox"
                        className="savedStylesManagerToolContainerTitleContainerCol01IconBox"
                    >
                        <img
                            id="savedStylesManagerToolContainerTitleBoxIconImg"
                            src="/SVGicons/stylesindent-black.svg"
                            alt="Save Tag"
                            style={{ width: '24px', height: '24px' }}
                        />
                    </div>
                    <div
                        id="savedStylesManagerToolContainerTitleContainerCol02TitleBox"
                        className="savedStylesManagerToolContainerTitleContainerCol02TitleBox"
                    >
                        <p
                            id="toolManagerTitleStyles"
                        >
                            Saved Styles Manager
                        </p>

                    </div>
                    <div
                        id="savedStylesManagerToolContainerTitleContainerCol03ButtonBox"
                        className="savedStylesManagerToolContainerTitleContainerCol03ButtonBox"
                    >
                        <Button
                            id="closeOpenToolManager"
                            className="closeOpenToolManager"
                            onClick={() => {
                                findAndClickHideCardMenusButton();
                            }}
                        >
                            <img
                                id="closeOpenToolManagerImg"
                                className="closeOpenToolManagerImg"
                                src="/SVGicons/X-white.svg"
                                alt="Close"
                                style={{ width: '12px', height: '12px' }}
                            />
                        </Button>
                    </div>
                </div>
            </div>




            {/* Display saved styles */}
            {savedStyles.map((style, index) => (
                <div
                    key={index}
                    id={`savedStylesButtonContainerMain-${index}`}
                    className="savedStylesButtonContainerMain"
                >


                    <div id={`savedStylesButtonContainer-${index}`} className="savedStylesButtonContainerHoverFixedOuter">
                        <div id="applyButtonsContainer" className="applyButtonsContainerOuter">

                            <div className="savedStyleNameHeaderText">
                                {savedStyles[index].name || `Style ${index + 1}`}
                            </div>

                            <div id="applyButtonsContainerButtonFresh" className="applyButtonsContainerButton">
                                {/* FRESH APPLY Button for each style */}
                                <Button
                                    id={`buttonClearStylingThenApplySavedStyle-${index}`}
                                    variant="success"
                                    size="sm"
                                    className="m-1 savedStylesButtonFreshApplyOuter"
                                    onClick={() => {
                                        const editorRef = textBoxRefs.current[lastFocusedEditorKey];
                                        if (!editorRef) {
                                            console.warn("No editor reference found for", lastFocusedEditorKey);
                                            return;
                                        }
                                        const quill = editorRef.getEditor?.();
                                        if (!quill) {
                                            console.warn("Quill editor not available on", lastFocusedEditorKey);
                                            return;
                                        }
                                        const range = quill.getSelection();
                                        if (range && range.length > 0) {
                                            // Clear all styles
                                            quill.removeFormat(range.index, range.length);

                                            // Then trigger the existing Apply button
                                            const applyButton = document.getElementById(`buttonSavedStyleApply-${index}`);
                                            if (applyButton) {
                                                applyButton.click();
                                            } else {
                                                console.warn(`Apply button not found for index ${index}`);
                                            }
                                        } else {
                                            console.warn("No text selected in editor:", lastFocusedEditorKey);
                                        }
                                    }}
                                >
                                    <div id={`buttonContainerFreshApplyParent-${savedStyles[index].name}`}
                                        className="buttonContainerFreshApplyParent">
                                        <div
                                            id={`buttonContainerFreshApplyImage-${savedStyles[index].name}`}
                                            className="buttonContainerFreshApplyImage">
                                            <img
                                                id={`buttonContainerFreshApplyImageImg-${savedStyles[index].name}`}
                                                alt={`Fresh Apply ${savedStyles[index].name}`}
                                                className="buttonContainerFreshApplyImageImg"
                                            />
                                        </div>
                                        <div
                                            id={`buttonContainerFreshApplyText-${savedStyles[index].name}`}
                                            className="buttonContainerFreshApplyText">
                                            {`FRESH APPLY: ${savedStyles[index].name || `Style ${index + 1}`}`}
                                        </div>
                                    </div>
                                </Button>
                            </div>
                            <div id="applyButtonsContainerButtonMerge" className="applyButtonsContainerButton">
                                {/* MERGE APPLY for each style */}
                                <Button
                                    id={`buttonSavedStyleApply-${index}`}
                                    variant="outline-success"
                                    size="sm"
                                    className="m-1 savedStylesButtonMergeApplyOuter"
                                    onClick={() => {
                                        const editorRef = textBoxRefs.current[lastFocusedEditorKey];
                                        if (!editorRef) {
                                            console.warn("No editor reference found for", lastFocusedEditorKey);
                                            return;
                                        }
                                        const quill = editorRef.getEditor?.();
                                        if (!quill) {
                                            console.warn("Quill editor not available on", lastFocusedEditorKey);
                                            return;
                                        }
                                        const range = quill.getSelection();
                                        if (range && range.length > 0) {
                                            Object.entries(style).forEach(([format, value]) => {
                                                quill.format(format, value);
                                            });
                                        } else {
                                            console.warn("No text selected in editor:", lastFocusedEditorKey);
                                        }
                                        // ✅ New function added as the last thing triggered
                                        console.log(`Data for savedStyles[${index}]:`, savedStyles[index]);
                                    }}
                                >
                                    <div id={`buttonContainerMergeApplyParent-${savedStyles[index].name}`}
                                        className="buttonContainerMergeApplyParent">
                                        <div
                                            id={`buttonContainerMergeApplyImage-${savedStyles[index].name}`}
                                            className="buttonContainerMergeApplyImage">
                                            <img
                                                id={`buttonContainerMergeApplyImageImg-${savedStyles[index].name}`}
                                                alt={`Merge Apply ${savedStyles[index].name}`}
                                                className="buttonContainerMergeApplyImageImg"
                                            />
                                        </div>
                                        <div
                                            id={`buttonContainerMergeApplyText-${savedStyles[index].name}`}
                                            className="buttonContainerMergeApplyText">

                                            {`MERGE APPLY: ${savedStyles[index].name || `Style ${index + 1}`}`}
                                        </div>
                                    </div>
                                </Button>
                            </div>

                            <div id="buttonContainerFavsAddTo"
                                className=" applyButtonsContainerButton">
                                {/* ADD to FAVS for each style */}
                                <Button
                                    id={`buttonAddToFavoriteSavedStyles-${index}`}
                                    size="sm"
                                    variant="success"
                                    className="m-1 buttonAddToFavs"
                                    style={{ padding: '2px 6px', fontSize: '0.65rem', fontWeight: 'bold' }}
                                    onClick={() => {
                                        toggleFavoriteVisible(index, true);
                                        findButtonFavoriteSavedStylesForStyleLibrary(index);
                                    }}
                                >
                                    <div
                                        id={`buttonAddToFavsParent-${savedStyles[index].name}`}
                                        className="buttonAddToFavsParent"
                                    >
                                        <div
                                            id={`buttonAddToFavsImage-${savedStyles[index].name}`}
                                            className="buttonAddToFavsImage"
                                        >
                                            <img
                                                id={`buttonAddToFavsImageImg-${savedStyles[index].name}`}
                                                src="/SVGicons/favorite-green-white.svg"
                                                alt={`Add to Favs ${savedStyles[index].name}`}
                                                style={{ width: '24px', height: '24px' }}
                                                className="buttonAddToFavsImageImg"
                                            />
                                        </div>
                                        <div
                                            id={`buttonAddToFavsText-${savedStyles[index].name}`}
                                            className="buttonAddToFavsText"
                                        >
                                            {`ADD to Favs: ${savedStyles[index].name || `${index + 1}`}`}
                                        </div>
                                    </div>
                                </Button>
                            </div>
                            <div id="buttonContainerFavsRemoveFrom"
                                className=" applyButtonsContainerButton">
                                {/* REMOVE from FAVS for each style */}
                                <Button
                                    id={`buttonRemoveFromFavoriteSavedStyles-${index}`}
                                    size="sm"
                                    variant="outline-danger"
                                    className="m-1 buttonRemoveFromFavs"
                                    style={{ padding: '2px 6px', fontSize: '0.65rem', fontWeight: 'bold' }}
                                    onClick={() => {
                                        toggleFavoriteVisible(index, false);
                                        findButtonFavoriteSavedStylesForStyleLibrary(index);
                                    }}
                                >

                                    <div
                                        id={`buttonRemoveFromFavsParent-${savedStyles[index].name}`}
                                        className="buttonRemoveFromFavsParent"
                                    >
                                        <div
                                            id={`buttonRemoveFromFavsImage-${savedStyles[index].name}`}
                                            className="buttonRemoveFromFavsImage"
                                        >
                                            <img
                                                id={`buttonRemoveFromFavsImageImg-${savedStyles[index].name}`}
                                                src="/SVGicons/favorite-black-gold.svg"
                                                alt={`Remove from Favs ${savedStyles[index].name}`}
                                                style={{ width: '24px', height: '24px' }}
                                                className="buttonRemoveFromFavsImageImg"
                                            />
                                        </div>
                                        <div
                                            id={`buttonRemoveFromFavsText-${savedStyles[index].name}`}
                                            className="buttonRemoveFromFavsText"
                                        >
                                            {`REMOVE from Favs: ${savedStyles[index].name || `${index + 1}`}`}
                                        </div>
                                    </div>
                                </Button>
                            </div>

                        </div>
                        <div id={`savedStylesButtonContainerHoverFixedInner-${index}`} className="savedStylesButtonContainerHoverFixedInner">

                            {favoriteVisible[index] && (
                                <Button
                                    id={`buttonFavoriteSavedStylesForStyleLibrary-${index}`}
                                    size="sm"
                                    variant="info"
                                    className="m-1 buttonFavoriteSavedStylesForStyleLibrary"
                                    style={{ padding: '2px 6px', fontSize: '0.65rem', fontWeight: 'bold', gap: '4px', display: 'none' }}
                                >
                                    <img
                                        src="/SVGicons/favorite-black.svg"
                                        alt="Favorite"
                                        style={{ width: '12px', height: '12px', marginRight: '0px' }}
                                    />
                                </Button>
                            )}


                            <div id="applyButtonsContainerHoverStuck" className="applyButtonsContainer">




                                <div id="applyButtonsContainerButtonFresh" className="applyButtonsContainerButton">
                                    {/* FRESH APPLY Clear Styling Then Apply Saved Style Button for each style */}
                                    <Button
                                        id={`buttonClearStylingThenApplySavedStyle-${index}`}
                                        variant="success"
                                        size="sm"
                                        className="m-1 savedStylesButtonFreshApply"
                                        onClick={() => {
                                            const editorRef = textBoxRefs.current[lastFocusedEditorKey];
                                            if (!editorRef) {
                                                console.warn("No editor reference found for", lastFocusedEditorKey);
                                                return;
                                            }
                                            const quill = editorRef.getEditor?.();
                                            if (!quill) {
                                                console.warn("Quill editor not available on", lastFocusedEditorKey);
                                                return;
                                            }
                                            const range = quill.getSelection();
                                            if (range && range.length > 0) {
                                                // Clear all styles
                                                quill.removeFormat(range.index, range.length);

                                                // Then trigger the existing Apply button
                                                const applyButton = document.getElementById(`buttonSavedStyleApply-${index}`);
                                                if (applyButton) {
                                                    applyButton.click();
                                                } else {
                                                    console.warn(`Apply button not found for index ${index}`);
                                                }
                                            } else {
                                                console.warn("No text selected in editor:", lastFocusedEditorKey);
                                            }
                                        }}
                                    >
                                        <div id={`buttonContainerFreshApplyParent-${savedStyles[index].name}`}
                                            className="buttonContainerFreshApplyParent">
                                            <div
                                                id={`buttonContainerFreshApplyImage-${savedStyles[index].name}`}
                                                className="buttonContainerFreshApplyImage">
                                                <img
                                                    id={`buttonContainerFreshApplyImageImg-${savedStyles[index].name}`}
                                                    alt={`Fresh Apply ${savedStyles[index].name}`}
                                                    className="buttonContainerFreshApplyImageImg"
                                                />
                                            </div>
                                            <div
                                                id={`buttonContainerFreshApplyText-${savedStyles[index].name}`}
                                                className="buttonContainerFreshApplyText">
                                                {`FRESH APPLY: ${savedStyles[index].name || `Style ${index + 1}`}`}
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                                <div id="applyButtonsContainerButtonMerge" className="applyButtonsContainerButton">
                                    {/* MERGE APPLY Apply Style Button for each style */}
                                    <Button
                                        id={`buttonSavedStyleApply-${index}`}
                                        variant="outline-success"
                                        size="sm"
                                        className="m-1 savedStylesButtonMergeApply"
                                        onClick={() => {
                                            const editorRef = textBoxRefs.current[lastFocusedEditorKey];
                                            if (!editorRef) {
                                                console.warn("No editor reference found for", lastFocusedEditorKey);
                                                return;
                                            }
                                            const quill = editorRef.getEditor?.();
                                            if (!quill) {
                                                console.warn("Quill editor not available on", lastFocusedEditorKey);
                                                return;
                                            }
                                            const range = quill.getSelection();
                                            if (range && range.length > 0) {
                                                Object.entries(style).forEach(([format, value]) => {
                                                    quill.format(format, value);
                                                });
                                            } else {
                                                console.warn("No text selected in editor:", lastFocusedEditorKey);
                                            }
                                            // ✅ New function added as the last thing triggered
                                            console.log(`Data for savedStyles[${index}]:`, savedStyles[index]);
                                        }}
                                    >
                                        <div id={`buttonContainerMergeApplyParent-${savedStyles[index].name}`}
                                            className="buttonContainerMergeApplyParent">
                                            <div
                                                id={`buttonContainerMergeApplyImage-${savedStyles[index].name}`}
                                                className="buttonContainerMergeApplyImage">
                                                <img
                                                    id={`buttonContainerMergeApplyImageImg-${savedStyles[index].name}`}
                                                    alt={`Merge Apply ${savedStyles[index].name}`}
                                                    className="buttonContainerMergeApplyImageImg"
                                                />
                                            </div>
                                            <div
                                                id={`buttonContainerMergeApplyText-${savedStyles[index].name}`}
                                                className="buttonContainerMergeApplyText">

                                                {`MERGE APPLY: ${savedStyles[index].name || `Style ${index + 1}`}`}
                                            </div>
                                        </div>
                                    </Button>
                                </div>


                            </div>


                            <div id="addFavsRemoveFavsEditDeleteButtonsContainer" className="addFavsRemoveFavsEditDeleteButtonsContainer">



                                <div id="buttonContainerFavsAddTo"
                                    className="addFavsRemoveFavsEditDeleteButtonsContainerButton applyButtonsContainerButton buttonAddToFavoriteSavedStylesHoverStuckHidden">
                                    <Button
                                        id={`buttonAddToFavoriteSavedStylesHoverStuck-${index}`}
                                        size="sm"
                                        variant="success"
                                        className="m-1 buttonAddToFavs"
                                        style={{ padding: '2px 6px', fontSize: '0.65rem', fontWeight: 'bold' }}
                                        onClick={() => {
                                            toggleFavoriteVisible(index, true);
                                            findButtonFavoriteSavedStylesForStyleLibrary(index);
                                        }}
                                    >
                                        <div
                                            id={`buttonAddToFavsParent-${savedStyles[index].name}`}
                                            className="buttonAddToFavsParent"
                                        >
                                            <div
                                                id={`buttonAddToFavsImage-${savedStyles[index].name}`}
                                                className="buttonAddToFavsImage"
                                            >
                                                <img
                                                    id={`buttonAddToFavsImageImg-${savedStyles[index].name}`}
                                                    src="/SVGicons/favorite-green-white.svg"
                                                    alt={`Add to Favs ${savedStyles[index].name}`}

                                                    className="buttonAddToFavsImageImg"
                                                />
                                            </div>
                                            <div
                                                id={`buttonAddToFavsText-${savedStyles[index].name}`}
                                                className="buttonAddToFavsText"
                                            >
                                                {`ADD to Favs: ${savedStyles[index].name || `${index + 1}`}`}
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                                <div id="buttonContainerFavsRemoveFrom"
                                    className="addFavsRemoveFavsEditDeleteButtonsContainerButton applyButtonsContainerButton buttonRemoveFromFavoriteSavedStylesHoverStuckHidden">
                                    <Button
                                        id={`buttonRemoveFromFavoriteSavedStylesHoverStuck-${index}`}
                                        size="sm"
                                        variant="outline-danger"
                                        className="m-1 buttonRemoveFromFavs"

                                        onClick={() => {
                                            toggleFavoriteVisible(index, false);
                                            findButtonFavoriteSavedStylesForStyleLibrary(index);
                                        }}
                                    >

                                        <div
                                            id={`buttonRemoveFromFavsParent-${savedStyles[index].name}`}
                                            className="buttonRemoveFromFavsParent"
                                        >
                                            <div
                                                id={`buttonRemoveFromFavsImage-${savedStyles[index].name}`}
                                                className="buttonRemoveFromFavsImage"
                                            >
                                                <img
                                                    id={`buttonRemoveFromFavsImageImg-${savedStyles[index].name}`}
                                                    src="/SVGicons/favorite-black-gold.svg"
                                                    alt={`Remove from Favs ${savedStyles[index].name}`}
                                                    style={{ width: '24px', height: '24px' }}
                                                    className="buttonRemoveFromFavsImageImg"
                                                />
                                            </div>
                                            <div
                                                id={`buttonRemoveFromFavsText-${savedStyles[index].name}`}
                                                className="buttonRemoveFromFavsText"
                                            >
                                                {`REMOVE from Favs: ${savedStyles[index].name || `${index + 1}`}`}
                                            </div>
                                        </div>
                                    </Button>
                                </div>


                                <div id="buttonContainerSavedStyleEdit"
                                    className="addFavsRemoveFavsEditDeleteButtonsContainerButton">
                                    {/* EDIT Saved Style Button for each style */}
                                    <Button
                                        id={`buttonSavedStyleEdit-${index}`}
                                        variant="warning"
                                        size="sm"
                                        className="m-1 buttonSavedStyleEdit"

                                        onClick={() => {
                                            // Hide all other edit panels
                                            savedStyles.forEach((_, i) => {
                                                const otherDiv = document.getElementById(`editSavedStyleDiv-${i}`);
                                                if (otherDiv && i !== index) {
                                                    otherDiv.style.display = 'none';
                                                }
                                            });

                                            // Then toggle the clicked one
                                            const editDiv = document.getElementById(`editSavedStyleDiv-${index}`);
                                            const input = document.getElementById(`editSavedStyleInput-${index}`);
                                            if (editDiv) {
                                                const isVisible = editDiv.style.display === 'block';
                                                editDiv.style.display = isVisible ? 'none' : 'block';

                                                if (!isVisible && input) {
                                                    input.value = `Style ${index + 1}`; // Pre-fill input with name

                                                    Object.entries(style).forEach(([format, value]) => {
                                                        input.style[format] = value;
                                                    });
                                                }

                                                applySavedStyleStylingToSavedStyleName(index);
                                            }
                                        }}
                                    >
                                        <div
                                            id={`buttonSavedStyleEditParent-${savedStyles[index].name}`}
                                            className="buttonSavedStyleEditParent"
                                        >
                                            <div
                                                id={`buttonSavedStyleEditImage-${savedStyles[index].name}`}
                                                className="buttonSavedStyleEditImage"
                                            >
                                                <img
                                                    id={`buttonSavedStyleEditImageImg-${savedStyles[index].name}`}
                                                    alt={`Edit Saved Style ${savedStyles[index].name}`}
                                                    className="buttonSavedStyleEditImageImg"
                                                />
                                            </div>
                                            <div
                                                id={`buttonSavedStyleEditText-${savedStyles[index].name}`}
                                                className="buttonSavedStyleEditText"
                                            >
                                                {`EDIT: ${savedStyles[index].name || `Style ${index + 1}`}`}
                                            </div>
                                        </div>

                                    </Button>
                                </div>
                                <div id="buttonContainerSavedStyleDelete"
                                    className="addFavsRemoveFavsEditDeleteButtonsContainerButton">
                                    {/* DELETE Saved Style Button for each style */}
                                    <Button
                                        id={`buttonSavedStyleDelete-${index}`}
                                        variant="danger"
                                        size="sm"
                                        className="m-1 buttonSavedStyleDelete"
                                        style={{ padding: '2px 6px', fontSize: '0.65rem', fontWeight: 'bold' }}
                                        onClick={() => {
                                            // First, find and click the corresponding REMOVE button if the style is a favorite
                                            if (favoriteVisible[index]) {
                                                const removeButton = document.getElementById(`buttonRemoveFromFavoriteSavedStyles-${index}`);
                                                if (removeButton) {
                                                    // Click the REMOVE button first to remove from favorites
                                                    removeButton.click();
                                                }
                                            }

                                            // Wait a short time to let the REMOVE action complete
                                            setTimeout(() => {
                                                // Then proceed with existing delete functionality
                                                findSavedStylesButtonContainerToDelete(index);

                                                // Update local favorite visibility state
                                                setFavoriteVisible(prev => {
                                                    const newVisibility = {};

                                                    // Create new map without the deleted index and shifting down remaining indices
                                                    Object.entries(prev).forEach(([key, value]) => {
                                                        const keyNum = parseInt(key, 10);
                                                        if (keyNum < index) {
                                                            // Keep entries before the deleted index
                                                            newVisibility[keyNum] = value;
                                                        } else if (keyNum > index) {
                                                            // Shift down entries after the deleted index
                                                            newVisibility[keyNum - 1] = value;
                                                        }
                                                        // Skip the deleted index
                                                    });

                                                    return newVisibility;
                                                });

                                                onDeleteSavedStyle(index);
                                                buttonSavedStyleDeleteScanFixedPositionFavoriteStylesContainer(index);
                                            }, 50); // Small delay to ensure the REMOVE action completes
                                        }}
                                    >
                                        <div
                                            id={`buttonSavedStyleDeleteParent-${savedStyles[index].name}`}
                                            className="buttonSavedStyleDeleteParent"
                                        >
                                            <div
                                                id={`buttonSavedStyleDeleteImage-${savedStyles[index].name}`}
                                                className="buttonSavedStyleDeleteImage"
                                            >
                                                <img
                                                    id={`buttonSavedStyleDeleteImageImg-${savedStyles[index].name}`}
                                                    alt={`Delete Saved Style ${savedStyles[index].name}`}
                                                    className="buttonSavedStyleDeleteImageImg"
                                                />
                                            </div>
                                            <div
                                                id={`buttonSavedStyleDeleteText-${savedStyles[index].name}`}
                                                className="buttonSavedStyleDeleteText"
                                            >
                                                {`DELETE: ${savedStyles[index]?.name || `Style ${index + 1}`}`}
                                            </div>
                                        </div>

                                    </Button>
                                </div>

                            </div>



                            {/* CONSOLE LOG Saved Style Props */}
                            < Button
                                id={`consoleLogSavedStyleProps-${index}`}
                                size="sm"
                                variant="outline-primary"
                                className="m-1"
                                style={{ padding: '2px 6px', fontSize: '0.65rem', fontWeight: 'bold', display: 'none' }}
                                onClick={() => consoleLogSavedStyleProps(index)}
                            >
                                {`LOG Props: ${savedStyles[index].name || `${index + 1}`}`}
                            </Button>




                            {/* Edit Panel - initially hidden */}
                            <ToolSavedStylesContainerEditSavedStyleDiv
                                index={index}
                                style={style}
                                setSavedStyles={setSavedStyles}
                                clearTextFormattingInSavedStyle={clearTextFormattingInSavedStyle}
                                saveCurrentStyleNamesStylingToSavedStyle={saveCurrentStyleNamesStylingToSavedStyle}
                                clickButtonEditStyleToolDiscard={clickButtonEditStyleToolDiscard}
                                clickButtonEditStyleToolSave123={clickButtonEditStyleToolSave123}
                            />
                        </div >


                    </div >
                    <div id="buttonContainerSavedStyleDelete"
                        className="addFavsRemoveFavsEditDeleteButtonsContainerButton containerCenter">
                        {/* DELETE Saved Style Button for each style */}
                        <Button
                            id={`buttonSavedStyleDelete-${index}`}
                            variant="danger"
                            size="sm"
                            className="m-1 buttonSavedStyleDelete"
                            style={{ padding: '2px 6px', fontSize: '0.65rem', fontWeight: 'bold' }}
                            onClick={() => {
                                // First, find and click the corresponding REMOVE button if the style is a favorite
                                if (favoriteVisible[index]) {
                                    const removeButton = document.getElementById(`buttonRemoveFromFavoriteSavedStyles-${index}`);
                                    if (removeButton) {
                                        // Click the REMOVE button first to remove from favorites
                                        removeButton.click();
                                    }
                                }

                                // Wait a short time to let the REMOVE action complete
                                setTimeout(() => {
                                    // Then proceed with existing delete functionality
                                    findSavedStylesButtonContainerToDelete(index);

                                    // Update local favorite visibility state
                                    setFavoriteVisible(prev => {
                                        const newVisibility = {};

                                        // Create new map without the deleted index and shifting down remaining indices
                                        Object.entries(prev).forEach(([key, value]) => {
                                            const keyNum = parseInt(key, 10);
                                            if (keyNum < index) {
                                                // Keep entries before the deleted index
                                                newVisibility[keyNum] = value;
                                            } else if (keyNum > index) {
                                                // Shift down entries after the deleted index
                                                newVisibility[keyNum - 1] = value;
                                            }
                                            // Skip the deleted index
                                        });

                                        return newVisibility;
                                    });

                                    onDeleteSavedStyle(index);
                                    buttonSavedStyleDeleteScanFixedPositionFavoriteStylesContainer(index);
                                }, 50); // Small delay to ensure the REMOVE action completes
                            }}
                        >
                            <div
                                id={`buttonSavedStyleDeleteParent-${savedStyles[index].name}`}
                                className="buttonSavedStyleDeleteParent"
                            >
                                <div
                                    id={`buttonSavedStyleDeleteImage-${savedStyles[index].name}`}
                                    className="buttonSavedStyleDeleteImage"
                                >
                                    <img
                                        id={`buttonSavedStyleDeleteImageImg-${savedStyles[index].name}`}
                                        alt={`Delete Saved Style ${savedStyles[index].name}`}
                                        className="buttonSavedStyleDeleteImageImg"
                                    />
                                </div>
                                <div
                                    id={`buttonSavedStyleDeleteText-${savedStyles[index].name}`}
                                    className="buttonSavedStyleDeleteText"
                                >
                                    {`ME DELETE: ${savedStyles[index]?.name || `Style ${index + 1}`}`}
                                </div>
                            </div>

                        </Button>
                    </div>

                </div >
            ))
            }
        </div >
    );
};

export default ToolSavedStylesContainer;
